import React from 'react'
import "./VideoPart.scss"

export default function VideoPart() {
    return (
        <section className="video-page" > 
            <div className="video-implatation">
            <div yitVideo="449488" stream="https://ynet-lh.akamaihd.net/i/ynet_1@123290/master.m3u8" title="לבנון"
                ads="1" id="livestream" data-title="לבנון"></div>
            </div>
        </section>
    )
}
